import React from 'react';
import {HomeGameFloorItem} from '../home.type';
import {View} from 'react-native';
import HomeCategory from '@/components/business/home-category/home-category';

// 1. 抽取常量
const SLIDE_WIDTHS = {
  PROMOTION: 0.48,
  GAME: 0.28,
  SPORTS: '19rem',
};
// 渲染空状态区域
const renderEmptySection = (floor: HomeGameFloorItem) => {
  return (
    <View>
      <HomeCategory
        key={floor.id}
        title={floor.name}
        icon={floor.categoryPic}
        list={[]}
        swiperSlideClassName={SLIDE_WIDTHS.SPORTS}
        rightContent={<div>All</div>}
        renderItem={() => <></>}
      />
    </View>
  );
};

export default renderEmptySection;
